import Swiper, { Autoplay, Navigation, Pagination,} from 'swiper';

Swiper.use([Autoplay,Navigation,Pagination]);

// TOPページのMV
let banquetSwiper = null;
const banquetSwiperInit = () => {
  banquetSwiper = new Swiper('.p-banquet-menu__items-wrap', {
    autoHeight: true,
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: '.p-banquet-menu__slide-pagenation',
      clickable: true,
    },
    navigation: {
      prevEl: '.p-banquet-menu__slide-prev',
      nextEl: '.p-banquet-menu__slide-next',
    },
    autoplay: false,
  });
}
let layoutSwiper = null;
const layoutSwiperInit = () => {
  layoutSwiper = new Swiper('.p-banquet-layout__styles-wrap', {
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: '.p-banquet-layout__slide-pagenation',
      clickable: true,
    },
    navigation: {
      prevEl: '.p-banquet-layout__slide-prev',
      nextEl: '.p-banquet-layout__slide-next',
    },
    autoplay: false,
  });
}

const mediaQueryPc = window.matchMedia('(max-width: 768px)');

const listener = (event) => {
  if (event.matches) {
    banquetSwiperInit();
    layoutSwiperInit();
  } else if(banquetSwiper, layoutSwiper) {
    banquetSwiper.destroy(false, true);
    layoutSwiper.destroy(false, true);
  }
};

mediaQueryPc.addEventListener('change', listener);

listener(mediaQueryPc);

